import { MultiSelectParameter } from '@drivingdoc/shared-types/reports';
import Grid from '@mui/material/Grid';

import MultiSelectAutocompleteInput from 'components/FormInputs/MultiSelectAutocompleteInput';

interface MultiSelectParameterFieldProps {
  parameter: MultiSelectParameter;
}

export default function MultiSelectParameterField({ parameter }: MultiSelectParameterFieldProps) {
  const { config } = parameter;

  return (
    <Grid size={12}>
      <MultiSelectAutocompleteInput
        name={parameter.name}
        label={parameter.label}
        helpText={parameter.helpText}
        options={config.options}
        placeholder={config.placeholder}
        includeSelectAll={config.includeSelectAll}
        minSelection={config.minSelection}
        maxSelection={config.maxSelection}
        // disablePortal
      />
    </Grid>
  );
}
